module.exports = __webpack_public_path__ + "img/png.3cab5c98.png";